<template>
  <!-- 筛选标签 -->
  <div class="app-search-tag-body">
    <SearchTag ref="Plate" :tags="tags.plate.name"></SearchTag>
    <SearchTag ref="Region" :tags="tags.region.name"></SearchTag>
    <SearchTag ref="NewsType" :tags="tags.newsType.name"></SearchTag>
    <SearchTag ref="OpenType" :tags="tags.openType.name"></SearchTag>
  </div>
</template>

<script>

import SearchTag from "@/views/share/search/SearchTag";

export default {
  name: "SearchNews",
  components: {
    SearchTag
  },
  data() {
    return {
      tags: {
        plate: {
          name: "板块",
          data: [
            {
              tagName: '版本周报'
            },
            {
              tagName: '焦点关注'
            },
            {
              tagName: '最新教学'
            },
            {
              tagName: 'B站星探'
            },
            {
              tagName: '插件评测'
            }
          ]
        },
        region: {
          name: "地区",
          data: [
            {
              tagName: '国内'
            },
            {
              tagName: '国外'
            }
          ]
        },
        newsType: {
          name: "类型",
          data: [
            {
              tagName: '视频'
            },
            {
              tagName: '文本'
            }
          ]
        },
        openType: {
          name: "内容",
          data: [
            {
              tagName: '原创'
            },
            {
              tagName: '授权转载'
            }
          ]
        }
      }
    }
  }
}
</script>